import Dialog from "../../atoms/dialog";
import { useState } from 'react'
import DeleteSimulation from "../simulations/DeleteSimulation";


const DeleteSimulationAlert = (props) => {
    const { onCompletion, element, onClose } = props;
    const [open, setOpen] = useState(false)
    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (
        <Dialog
            open={true}
            handleClose={handleClose}
            paperProps={{ id: "deleteSimulationAlert" }}
        >
            <DeleteSimulation onCompletion={onCompletion} element={element} onClose={onClose} />

        </Dialog >
    )
}

export default DeleteSimulationAlert;